import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

const BusinessPortalIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 60 60">
      <path
        d="M52.6,0H5.5C2.4,0,0,2.4,0,5.5v47.1c0,3,2.4,5.5,5.5,5.5h47.1c3,0,5.5-2.4,5.5-5.5c0,0,0,0,0,0V5.5
	C58,2.4,55.6,0,52.6,0L52.6,0z M38.6,15.7c-0.1-1.4-0.3-2.8-0.6-4.2c3.9,2.1,7,5.4,8.9,9.5c-1,1.5-2.1,2.9-3.3,4.3
	c-1.5,1.8-3.2,3.5-4.9,5.1c-0.4,0.3-0.7,0.6-1.1,0.9c0.3-1.3,0.5-2.6,0.7-3.9s0.3-2.9,0.4-4.3C38.8,20.6,38.8,18.2,38.6,15.7
	L38.6,15.7z M28.8,9.2c2.4,0,4.8,0.4,7,1.3c0.4,1.8,0.6,3.6,0.8,5.4c0.2,2.3,0.3,4.7,0.1,7.1c0,0.4,0,0.9-0.1,1.3
	c-0.7-1.1-1.4-2.1-2.2-3.1c-0.9-1.2-1.8-2.3-2.8-3.4c-1.6-1.8-3.4-3.5-5.3-5.1c-1.1-0.9-2.2-1.8-3.3-2.6C24.9,9.5,26.9,9.2,28.8,9.2
	L28.8,9.2z M14.8,15c1.7-1.7,3.8-3.1,6-4.1c3.5,2.3,6.7,5.1,9.5,8.2l0.9,1.1c-1.3-0.3-2.6-0.5-3.9-0.7c-1.5-0.2-2.9-0.3-4.4-0.4
	c-0.9,0-1.8-0.1-2.7-0.1c-1.6,0-3.1,0.1-4.7,0.2c-1.4,0.1-2.8,0.3-4.2,0.5C12.3,18,13.5,16.4,14.8,15L14.8,15z M9,29
	c0-2.4,0.4-4.8,1.3-7.1c1.8-0.3,3.6-0.6,5.4-0.7c1.5-0.1,3-0.2,4.5-0.2c0.9,0,1.7,0,2.6,0.1l1.4,0.1c-1.1,0.7-2.2,1.5-3.2,2.3
	s-2.3,1.8-3.3,2.8c-1.8,1.6-3.5,3.4-5.1,5.3c-0.9,1.1-1.8,2.2-2.6,3.4C9.3,33,9,31,9,29L9,29z M18.9,42.3c0.1,1.4,0.3,2.8,0.5,4.2
	c-1.7-0.9-3.3-2.1-4.7-3.5c-1.7-1.7-3.1-3.7-4.1-5.9c1-1.5,2.1-3,3.3-4.4c1.5-1.8,3.2-3.5,4.9-5.1c0.3-0.3,0.6-0.6,1-0.9
	c-0.3,1.2-0.5,2.5-0.6,3.8C19.1,32,19,33.5,18.9,35C18.8,37.4,18.8,39.9,18.9,42.3L18.9,42.3z M28.8,48.8c-2.4,0-4.9-0.5-7.1-1.3
	c-0.3-1.8-0.6-3.5-0.7-5.3c-0.2-2.4-0.2-4.7-0.1-7.1c0-0.5,0.1-0.9,0.1-1.4c0.7,1.1,1.5,2.2,2.3,3.2s1.9,2.3,2.8,3.4
	c1.6,1.8,3.4,3.5,5.3,5.1c1.1,0.9,2.2,1.8,3.4,2.6C32.8,48.5,30.8,48.8,28.8,48.8L28.8,48.8z M42.8,43c-1.7,1.7-3.7,3.1-5.9,4.1
	c-1.5-1-3-2.1-4.4-3.3c-1.8-1.5-3.5-3.1-5.1-4.9c-0.3-0.3-0.6-0.7-0.9-1c1.3,0.3,2.6,0.5,3.9,0.7c1.4,0.2,2.9,0.3,4.3,0.4
	c0.9,0,1.8,0.1,2.7,0.1c1.5,0,3.1-0.1,4.6-0.2s2.8-0.3,4.2-0.5C45.4,40.1,44.2,41.6,42.8,43L42.8,43z M47.3,36.1
	c-1.8,0.3-3.6,0.6-5.4,0.7c-1.5,0.1-3,0.2-4.5,0.2c-0.9,0-1.8,0-2.6-0.1l-1.3-0.1c1.1-0.7,2.1-1.5,3.1-2.2s2.3-1.8,3.4-2.8
	c1.8-1.6,3.5-3.4,5.1-5.3c0.9-1.1,1.8-2.2,2.6-3.3c0.6,1.9,0.9,3.8,0.9,5.8C48.6,31.4,48.1,33.8,47.3,36.1z"
      />
    </SvgIcon>
  );
};

export default BusinessPortalIcon;
